import { useMemo } from 'react';

import { UserType } from '@enums/index';

import {
    useDeleteMenteeProfilePicMutation,
    useDeleteMentorProfilePicMutation,
} from '../api/personalInfo';
import { DeleteImagePayload } from '../types';

interface DeleteProfilePicProps {
    userType: UserType;
}

export default function useDeleteProfilePic({ userType }: DeleteProfilePicProps) {
    const [deleteMentorProfilePic, { isLoading: mentorLoading, isSuccess: mentorSuccess }] =
        useDeleteMentorProfilePicMutation();
    const [deleteMenteeProfilePic, { isLoading: menteeLoading, isSuccess: menteeSuccess }] =
        useDeleteMenteeProfilePicMutation();

    const isLoading = useMemo(() => mentorLoading || menteeLoading, [mentorLoading, menteeLoading]);

    const isSuccess = useMemo(() => mentorSuccess || menteeSuccess, [mentorSuccess, menteeSuccess]);

    const handleDeleteMentorProfilePic = async (payload: DeleteImagePayload) => {
        await deleteMentorProfilePic(payload);
    };

    const handleDeleteMenteeProfilePic = async (payload: DeleteImagePayload) => {
        await deleteMenteeProfilePic(payload);
    };

    const handleDeleteProfilePic = async (payload: DeleteImagePayload) => {
        switch (userType) {
            case UserType.Mentor:
                await handleDeleteMentorProfilePic(payload);
                break;
            case UserType.Mentee:
                await handleDeleteMenteeProfilePic(payload);
                break;
            default:
                break;
        }
    };
    return {
        handleDeleteProfilePic,
        isLoading,
        isSuccess,
    };
}
